import { render, staticRenderFns } from "./voorwaarden.vue?vue&type=template&id=c60598ec&"
import script from "./voorwaarden.vue?vue&type=script&lang=js&"
export * from "./voorwaarden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports